import uniqBy from "lodash/uniqBy";

import type { NoteBrowsingHistoryNode } from "~/client/components/search/hooks/useNoteBrowsingHistory";
import { type Connection } from "~/client/utils/relay";

export const distinctNoteBrowsingHistory = (
  entries: Connection<any>,
  limit: number,
): Connection<NoteBrowsingHistoryNode> => {
  const notNull = entries.edges.filter((e) => e.node.note);
  const unique = uniqBy(notNull, (e) => e.node.note!.path).slice(0, limit);
  return { edges: unique };
};
